import gql from 'graphql-tag';

import FragmentWrapper from 'graphql-client/FragmentWrapper';

import {PipelineStepEdgeFragment as PipelineStepEdgeFragmentType} from './__generated/PipelineStepEdgeFragment';

export const PIPELINE_STEP_EDGE_FRAGMENT = gql`
  fragment PipelineStepEdgeFragment on PipelineStepEdgeNode {
    fromStep {
      id
    }
    fromStepData {
      id
      name
    }
    fromStepDataIndex
    toStep {
      id
    }
    toStepData {
      id
      name
    }
    toStepDataIndex
  }
`;

export const PipelineStepEdgeFragment: FragmentWrapper<PipelineStepEdgeFragmentType> = {
  fragment: PIPELINE_STEP_EDGE_FRAGMENT,
  fragmentName: 'PipelineStepEdgeFragment',
};
